import {createReducer, on} from '@ngrx/store';
import {initialAppNavigationState} from './app-navigation.state.initial';
import {AppNavigationActions} from './app-navigation.actions';

export const appNavigationReducer = createReducer(
  initialAppNavigationState,

  on(AppNavigationActions.enableButton, (state, {buttonId}) => ({
    ...state,
    buttonStates: {...state.buttonStates, [buttonId]: true},
  })),

  on(AppNavigationActions.disableButton, (state, {buttonId}) => ({
    ...state,
    buttonStates: {...state.buttonStates, [buttonId]: false},
  })),

  on(AppNavigationActions.setButtonEnabled, (state, {buttonId, enabled}) => ({
    ...state,
    buttonStates: {...state.buttonStates, [buttonId]: enabled},
  })),

  on(AppNavigationActions.showButton, (state, {buttonId}) => ({
    ...state,
    buttonVisibility: {...state.buttonVisibility, [buttonId]: true},
  })),

  on(AppNavigationActions.hideButton, (state, {buttonId}) => ({
    ...state,
    buttonVisibility: {...state.buttonVisibility, [buttonId]: false},
  })),

  on(AppNavigationActions.setButtonVisibility, (state, {buttonId, visible}) => ({
    ...state,
    buttonVisibility: {...state.buttonVisibility, [buttonId]: visible},
  })),
);
